import React, { Component } from 'react';

import styles from './default.less';

interface Props extends React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
	styles: { select: string };
}

export default class Select extends Component<Props> {
	public static defaultProps = {
		styles,
	};

	public render() {
		const { styles, ...props } = this.props;

		return <select className={styles.select} {...props} />;
	}
}
